export default __webpack_public_path__ + "static/media/promo-text.79295344.svg";